/**
 * Created by roman.kupin on 9/21/2017.
 */


import { combineReducers } from "redux";
import contextSelector from "../components/context-selector/reducers/index";
import showcaseStories from "../components/showcase-stories/reducers/index";
import context from "./context";

const uiReducer = combineReducers({contextSelector, context, showcaseStories});

export default uiReducer;
